import {
  ToastController,
  AlertController,
  LoadingController,
} from '@ionic/angular';
import { Platform } from '@ionic/angular';

import { Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
import { GlobalService } from './globals';
import { Storage } from '@ionic/storage-angular';

import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { HTTP } from '@awesome-cordova-plugins/http/ngx';
import { IonSlides, NavController } from '@ionic/angular';
// import { WonderPush } from '@awesome-cordova-plugins/wonderpush/ngx';

@Injectable({
  providedIn: 'root',
})

export class AZUtils {
  // API_endpoint: String = "http://localhost:3001/";
  // DOC_endpoint: String = "http://localhost:3031/";
  // FIN_TECH_API_endpoint: String = "http://localhost:4600/";
  // FIN_TECH_DOC_endpoint: String = "http://localhost:4600/";

  API_endpoint: String = 'https://qa-api.agrizy.in/';
  DOC_endpoint: String = "https://qa-docs.agrizy.in/";
  FIN_TECH_API_endpoint: String = "https://qa-fintech-api.agrizy.in/";
  FIN_TECH_DOC_endpoint: String = "https://qa-fintech-api.agrizy.in/";

  // API_endpoint: String = "https://api.agrizy.in/";
  // DOC_endpoint: String = "https://docs.agrizy.in/";
  // FIN_TECH_API_endpoint: String = "https://ft-api.agrizy.in/";
  // FIN_TECH_DOC_endpoint: String = "https://ft-api.agrizy.in/";

  isLoading = false;

  constructor(
    private toastCtrl: ToastController,
    private alertCtrl: AlertController,
    private loadingCtrl: LoadingController,
    public platform: Platform,
    public mglobals: GlobalService,
    public navCtrl: NavController,
    private httpclient: HttpClient,
    private storage: Storage,
    private http: HTTP,
    // private wonderPush: WonderPush
  ) { }

  public async setSessionData() {
    await this.storage.get('user_obj').then((res) => {
      let muser_obj = res;
      this.mglobals.muser_id = muser_obj.user.user_id;
      // this.wonderPush.setUserId(muser_obj.user.user_id);
      this.mglobals.muser_fname = muser_obj.user.user_fname;
      this.mglobals.muser_lname = muser_obj.user.user_lname;
      this.mglobals.muser_email = muser_obj.user.user_email;
      this.mglobals.muser_type_id = muser_obj.user.user_type_id;
      this.mglobals.mcust_id = muser_obj.user.cust_id;
      this.mglobals.muser_mobile_isd = muser_obj.user.user_mobile_isd;
      this.mglobals.muser_mobile_no = muser_obj.user.user_mobile_no;
      this.mglobals.mses_key = muser_obj.user.ses_key;
      this.mglobals.mimpersonate_user_id = muser_obj.impersonate_user_id;
      this.mglobals.mimpersonate_log_id = muser_obj.impersonate_log_id;
      this.mglobals.mflag_agrizy_employee = muser_obj.user.flag_employee == 1 ? true : false;
      this.mglobals.mflag_kyc_veri = muser_obj.user.flag_kyc_veri == 1 ? true : false;
      this.mglobals.mflag_admin = muser_obj.user.flag_admin == 1 ? true : false;
      this.mglobals.mflag_impersonate = muser_obj.flag_impersonate == 1 ? true : false;
      this.mglobals.mflag_crea_cust = muser_obj.user.flag_crea_cust == 1 ? true : false;
      this.mglobals.mflag_fintech_access_rm = muser_obj.user.flag_fintech_access_rm == 1 ? true : false;
      if (muser_obj.user.flag_fintech_access_rm == 1) {
        this.mglobals.finTech_token = muser_obj.fin_tech.token;
        this.mglobals.mft_user_id = muser_obj.fin_tech.user.user_id;
      }
      this.mglobals.mflag_ipm_access_rm = muser_obj.user.flag_ipm_access_rm == 1 ? true : false;
      this.mglobals.mflag_ipm_access_admin = muser_obj.user.flag_ipm_access_admin == 1 ? true : false;
      this.mglobals.mflag_ipm_and_trading_access_rm = muser_obj.user.flag_ipm_and_trading_access_rm == 1 ? true : false;
      this.mglobals.mflag_tcb_access_trade_direct = muser_obj.user.flag_tcb_access_trade_direct == 1 ? true : false;
      this.mglobals.mflag_tcb_access_trade_fintech = muser_obj.user.flag_tcb_access_trade_fintech == 1 ? true : false;
      this.mglobals.mflag_tcb_category_head_approval = muser_obj.user.flag_tcb_category_head_approval == 1 ? true : false;
      this.mglobals.mflag_early_pmt_release = muser_obj.user.flag_early_pmt_release == 1 ? true : false;
      this.mglobals.mflag_supplier_early_pmt_rm_auth = muser_obj.user.flag_supplier_early_pmt_rm_auth == 1 ? true : false;
      this.mglobals.mflag_early_pmt_restriction = muser_obj.user.flag_early_pmt_restriction == 1 ? true : false;
      this.mglobals.mflag_rm_delegate = muser_obj.user.flag_rm_delegate == 1 ? true : false;
      this.mglobals.mflag_rpc_hsn_replacement = muser_obj.user.flag_rpc_hsn_replacement == 1 ? true : false;
      this.mglobals.mflag_cr_eval_check = muser_obj.user.flag_cr_eval_check == 1 ? true : false;
      this.mglobals.mflag_overseas_sale = muser_obj.user.flag_overseas_sale == 1 ? true : false;
    });

    // Restore token from storage
    await this.storage.get('agrizy_token').then((token) => {
      if (token) {
        this.mglobals.agrizy_token = token;
      }
    });
  }

  public getUUID() {
    return uuidv4();
  }

  // ---------------------------------------------------------------------------
  // Multi-currency helpers for the Overseas Sale screens (mapping §3).
  // Country -> currency / country -> locale maps are verbatim from the admin
  // tr_sales_overseas.js. Do NOT reuse the INR-only IndianNumberPipe here.
  // ---------------------------------------------------------------------------
  public m_country_currency_map: { [cc: string]: string } = {
    ID: 'IDR', IN: 'INR', US: 'USD', GB: 'GBP', AU: 'AUD',
    SG: 'SGD', AE: 'AED', MY: 'MYR', NG: 'NGN', SA: 'SAR'
  };

  public m_country_locale_map: { [cc: string]: string } = {
    ID: 'id-ID', IN: 'en-IN', US: 'en-US', GB: 'en-GB', AU: 'en-AU',
    SG: 'en-SG', AE: 'en-AE', MY: 'en-MY', NG: 'en-NG', SA: 'en-SA'
  };

  /** Resolve the ISO currency code for a country. Falls back to the raw country code. */
  public currencyForCountry(countryCode: string): string {
    if (!countryCode) {
      return '';
    }
    const cc = String(countryCode).toUpperCase();
    return this.m_country_currency_map[cc] || cc;
  }

  /** Resolve the locale string for a country. Falls back to 'en-US'. */
  public localeForCountry(countryCode: string): string {
    if (!countryCode) {
      return 'en-US';
    }
    const cc = String(countryCode).toUpperCase();
    return this.m_country_locale_map[cc] || 'en-US';
  }

  /**
   * Format a number for the country's locale, always with 2 decimals, prefixed
   * by the currency code (e.g. "IDR 18.648,65", "USD 1,250.00"). Mirrors the
   * admin fmt_idr(). A country missing from the map falls back to its raw code.
   */
  public fmtCurrency(value: any, countryCode: string): string {
    const num = parseFloat(value);
    const amount = isNaN(num) ? 0 : num;
    const locale = this.localeForCountry(countryCode);
    const currency = this.currencyForCountry(countryCode);
    let formatted: string;
    try {
      formatted = amount.toLocaleString(locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    } catch (err) {
      formatted = amount.toFixed(2);
    }
    return currency ? `${currency} ${formatted}` : formatted;
  }

  /**
   * Parse a user/locale formatted amount back to a number. Handles BOTH the raw
   * form '18648.65' and the IDR-grouped form '18.648,65'. Mirrors admin parse_idr().
   */
  public parseCurrency(str: any, countryCode?: string): number {
    if (str === null || str === undefined) {
      return 0;
    }
    const s = String(str).trim();
    if (s === '') {
      return 0;
    }
    // Grouped form using comma as decimal separator (e.g. '18.648,65')
    if (s.indexOf(',') !== -1) {
      const normalized = s.replace(/\./g, '').replace(',', '.');
      const val = parseFloat(normalized);
      return isNaN(val) ? 0 : val;
    }
    const val = parseFloat(s);
    return isNaN(val) ? 0 : val;
  }

  public setCompanyData(mcomp_obj) {
    this.mglobals.mcomp_name = mcomp_obj.comp_name;
    this.mglobals.mcomp_dname = mcomp_obj.comp_dname;
    this.mglobals.mcomp_key = mcomp_obj.comp_key;
  }

  public async presentToast(mnmsg) {
    const toast = await this.toastCtrl.create({
      message: mnmsg,
      duration: 3000,
      position: 'top',
    });
    toast.present();
  }

  async presentLoader(options: object) {
    // Dismiss all pending loaders before creating the new one
    await this.dismissLoader();

    await this.loadingCtrl.create(options).then((res) => {
      res.present();
    });
  }

  /* Dismiss all the pending loaders, if any */
  async dismissLoader() {
    while ((await this.loadingCtrl.getTop()) !== undefined) {
      await this.loadingCtrl.dismiss();
    }
  }

  public js_yyyy_mm_dd_hh_mm_ss() {
    var now, year, month, day, hour, minute, second;
    now = new Date();
    year = '' + now.getFullYear();
    month = '' + (now.getMonth() + 1);
    if (month.length == 1) {
      month = '0' + month;
    }
    day = '' + now.getDate();
    if (day.length == 1) {
      day = '0' + day;
    }
    hour = '' + now.getHours();
    if (hour.length == 1) {
      hour = '0' + hour;
    }
    minute = '' + now.getMinutes();
    if (minute.length == 1) {
      minute = '0' + minute;
    }
    second = '' + now.getSeconds();
    if (second.length == 1) {
      second = '0' + second;
    }
    return (
      year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second
    );
  }

  public async postData(url: string, requestBody: any) {
    let moptions = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };
    if (url != '"login", "verifyOTP"') {
      // moptions['x-access-token'] = this.mglobals.agrizy_token;
      moptions['x-session-key'] = this.mglobals.agrizy_session_key;
    }
    moptions['x-src-id'] = "1";
    url = this.API_endpoint + url;
    let mresp = null;
    await this.httpclient
      .post(url, JSON.stringify(requestBody), {
        headers: new HttpHeaders(moptions),
      })
      .toPromise()
      .then((res) => {
        mresp = res;
      })
      .catch((err) => {
        mresp = err.error;
        console.log('Error in postData Function : ' + JSON.stringify(requestBody));
        console.log('Received Response : ' + JSON.stringify(err))

      });
    try {
      if (mresp?.header?.status == 2) {
        console.log('Logging out...');
        this.presentToast(mresp.body.error.msg);
        this.storage.remove('agrizy_token');
        this.storage.remove('finTech_token');
        this.storage.remove('agrizy_session_key');
        this.storage.remove('finTech_session_key');
        this.storage.remove("user_obj");
        this.navCtrl.navigateRoot(['./select-language']);
        return {};
      }
      // Handle no_access flag - redirect to home if user doesn't have permission
      if (mresp?.body?.data?.no_access == 1) {
        console.log('Access denied - redirecting to home');
        this.presentToast(mresp?.body?.error?.msg || 'You do not have access to this feature.');
        this.navCtrl.navigateRoot(['./home']);
        return {};
      }
    } catch (err) {
      // console.log('Received Response : ' + JSON.stringify(mresp))
      console.log('Error in postData Function : ' + JSON.stringify(err));
    }
    return mresp;
  }

  public async finTechPostData(url: string, requestBody: any) {
    let moptions = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };
    if (url != '"login", "verifyOTP"') {
      // moptions['x-access-token'] = this.mglobals.finTech_token;
      moptions['x-session-key'] = this.mglobals.finTech_session_key;
    }
    moptions['x-src-id'] = "1";
    url = this.FIN_TECH_API_endpoint + url;
    let mresp = null;
    await this.httpclient
      .post(url, JSON.stringify(requestBody), {
        headers: new HttpHeaders(moptions),
      })
      .toPromise()
      .then((res) => {
        mresp = res;
      })
      .catch((err) => {
        mresp = err.error;
        console.log('Error in postData Function : ' + JSON.stringify(requestBody));
        console.log('Received Response : ' + JSON.stringify(err))

        // Check for force_login in error response
        if (mresp?.force_login == 1) {
          console.log('Logging out due to force_login in error response...');
          this.presentToast(mresp.msg || 'Authentication required');
          this.storage.remove('finTech_token');
          this.storage.remove('agrizy_session_key');
          this.storage.remove('finTech_session_key');
          this.storage.remove("user_obj");
          this.navCtrl.navigateRoot(['./select-language']);
          return {};
        }
      });
    try {
      if (mresp?.body?.data?.force_login == 1) {
        console.log('Logging out...');
        this.presentToast(mresp.body.error.msg);
        this.storage.remove('finTech_token');
        this.storage.remove('agrizy_session_key');
        this.storage.remove('finTech_session_key');
        this.storage.remove("user_obj");
        this.navCtrl.navigateRoot(['./select-language']);
        return {};
      }
    } catch (err) {
      console.log('Received Response : ' + JSON.stringify(mresp))
      console.log('Error in postData Function : ' + JSON.stringify(err));
    }
    return mresp;
  }

  public async finTechGetData(url: string) {
    let moptions = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };
    moptions['x-session-key'] = this.mglobals.finTech_session_key;
    moptions['x-src-id'] = "1";
    url = this.FIN_TECH_API_endpoint + url;
    let mresp = null;
    await this.httpclient
      .get(url, {
        headers: new HttpHeaders(moptions),
      })
      .toPromise()
      .then((res) => {
        mresp = res;
      })
      .catch((err) => {
        mresp = err.error;
        console.log('Error in finTechGetData Function');
        console.log('Received Response : ' + JSON.stringify(err))

        // Check for force_login in error response
        if (mresp?.force_login == 1) {
          console.log('Logging out due to force_login in error response...');
          this.presentToast(mresp.msg || 'Authentication required');
          this.storage.remove('finTech_token');
          this.storage.remove('agrizy_session_key');
          this.storage.remove('finTech_session_key');
          this.storage.remove("user_obj");
          this.navCtrl.navigateRoot(['./select-language']);
          return {};
        }
      });
    try {
      if (mresp?.body?.data?.force_login == 1) {
        console.log('Logging out...');
        this.presentToast(mresp.body.error.msg);
        this.storage.remove('finTech_token');
        this.storage.remove('agrizy_session_key');
        this.storage.remove('finTech_session_key');
        this.storage.remove("user_obj");
        this.navCtrl.navigateRoot(['./select-language']);
        return {};
      }
    } catch (err) {
      console.log('Received Response : ' + JSON.stringify(mresp))
      console.log('Error in finTechGetData Function : ' + JSON.stringify(err));
    }
    return mresp;
  }

  /**
   * Validate GRN date rules for Direct purchases and Sales.
   * Returns true if valid; shows a toast and returns false if invalid.
   */
  public validateGrnDate(
    mode: 'purchase' | 'sale',
    referenceDate: string | Date,
    grnDate: string | Date
  ): boolean {
    if (!referenceDate || !grnDate) {
      return true;
    }

    const normalize = (d: string | Date): Date => {
      const dateObj = typeof d === 'string' ? new Date(d) : d;
      return new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate());
    };

    const ref = normalize(referenceDate);
    const grn = normalize(grnDate);

    if (isNaN(ref.getTime()) || isNaN(grn.getTime())) {
      return true;
    }

    if (grn < ref) {
      if (mode === 'purchase') {
        this.presentToast(
          'For Direct purchases, GRN date must be on or after the purchase account date.'
        );
      } else {
        this.presentToast(
          'For Sales, GRN date must be on or after the sale date.'
        );
      }
      return false;
    }

    return true;
  }
}
